import { Helmet } from "react-helmet-async";

interface SEOProps {
	title: string;
	description: string;
	keywords: string;
	imageUrl: string;
	slug: string;
}

const SEO: React.FC<SEOProps> = ({
	title,
	description,
	keywords,imageUrl,
	slug,
}) => {
	return (
		<Helmet>
			<title>{title}</title>
			<meta
				name="keywords"
				content={keywords}
			/>
			<meta
				name="description"
				content={description}
			/>
			<meta
				property="og:title"
				content={title}
			/>
			<meta
				property="og:description"
				content={description}
			/>
			<meta
				property="og:image"
				content={imageUrl}
			/>
			<meta
				property="og:url"
				content={`https://www.scorpioclassics.com${slug}`}
			/>
		</Helmet>
	);
};

export default SEO;